<template>
    <div :class="{'bg-grid': showBackgroundGrid}" class="min-h-screen">
        <Head>
            <title>{{ pageTitle }}</title>
            <meta
                content="Anonymous VC Reviews, OpenScout Marketplace, Anonymous Founder Marketplace, Investor Lists, and much more."
                name="description">
            <meta :content="pageTitle" name="twitter:title">
            <meta :content="pageTitle" property="twitter:title">
            <meta :content="pageTitle" property="og:title">
            <meta content="website" property="og:type">
            <meta
                content="Anonymous VC Reviews, OpenScout Marketplace, Anonymous Founder Marketplace, Investor Lists, and much more."
                property="og:description">
            <meta content="/img/open-graph.jpg" property="og:image">
            <meta
                content="Anonymous VC Reviews, OpenScout Marketplace, Anonymous Founder Marketplace, Investor Lists, and much more."
                name="twitter:description">
            <meta content="/img/open-graph.jpg" name="twitter:image">
            <meta content="summary_large_image" name="twitter:card">
        </Head>


        <Header
            :account-navigation="accountNavigation" :hide-navigation="hideNavigation" :navigation="navigation"
            :user="user"/>


        <div class="mx-auto max-w-7xl px-4 sm:px-6 md:px-8 relative">
            <slot/>
        </div>

        <Toast v-if="toast" :toast="toast"/>
        <GlobalToast />
    </div>


</template>

<script>
import {computed} from 'vue';
import {Head, usePage} from '@inertiajs/vue3';
import Header from '@/Layouts/Legacy/2023/Partials/Header.vue';
import Toast from '@/Components/Legacy/2023/Toast.vue';
import GlobalToast from '@/Components/Toast/GlobalToast.vue';
// import {Userpilot} from 'userpilot';

export default {
    components: {
        Toast,
        Header,
        Head,
        GlobalToast,
    },
    props: {
        title: {
            type: String,
            required: false,
        },

        showBackgroundGrid: {
            type: Boolean,
            required: false,
            default: false,
        },

        hideNavigation: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup() {
        const navigation = computed(() => usePage().props.navigation);
        const user = computed(() => usePage().props.user);
        return {user, navigation};
    },
    data() {
        return {
            sidebarOpen: false,
            showUpgradeModal: true,
            secondaryNavigation: [
                // {name: 'Chat With Us', href: "javascript:Intercom('show');"},
                // {name: 'Knowledge Base', href: 'https://help.landscape.vc/'},
                // {
                //     name: 'About Us',
                //     href: this.route('marketing.about'),
                //     current: this.route().current('marketing.about')
                // },

            ],
            accountNavigation: [
                {name: 'Settings', href: this.route('settings.user'), method: 'GET'},
                {name: 'Logout', href: this.route('logout'), method: 'POST'},
            ]
        };
    },

    computed: {
        toast() {
            return this.$page.props.toast;
        },
        accountNavigationComputed() {
            if (!this.user) {
                return [];
            }

            return this.accountNavigation;
        },
        pageTitle() {
            if (this.title) {
                return this.title + ' - Landscape';
            }

            return 'Landscape - Making Fundraising better for everyone';
        }
    },


    mounted() {
        // if (this.user) {
        //     Userpilot.identify(this.user.uuid, {
        //         first_name: this.user.first_name,
        //         last_name: this.user.last_name,
        //         email: this.user.email,
        //         type: this.user.type,
        //         signals_enabled: this.user.signals_enabled,
        //     });
        // }
    },

    methods: {
        toggleSidebar(value) {
            this.sidebarOpen = value;
        }
    }

};
</script>
